import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import clsx from 'clsx';
    import { computed } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CContainerText',
  props: {
        className: {
            type: String,
            default: "",
        },
        secondary: {
            type: Boolean,
            default: false,
        }
    },
  setup(__props) {

const props = __props

    

    const classes = computed(() => {
        return clsx(
            props.className,
            props.secondary ? "text-capGrey" : "text-capDarkPurple font-semibold",
            "text-md"
        )
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", {
    class: _normalizeClass(_unref(classes))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})